<script>
import bem from '@/utils/bem';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import { mapActions, mapState } from 'vuex';
import TERMS from '@/pages/helpCenter/options';
import HelpCenters from '@/components/helpCenters/Help-centers.vue';

const STEP_NAME = {
  uploadType: 'SELECT OPTION STEP',
  shipKit: 'SHIP KIT OPTIONS STEP',
  imageUploader: 'IMAGE UPLOADER STEP',
  imageNotes: 'IMAGE NOTES STEP',
  imageColorization: 'IMAGE COLORIZATION STEP',
  imageUpgrade: 'IMAGE UPGRADE STEP',
  imageOptionPreselect: 'IMAGE OPTION PRESELECT STEP',
  createProducts: 'CREATE PRODUCTS STEP',
  createWizard: 'CREATE WIZARD STEP',
};

const {
  DIGITIZE_PAGES,
  ENHANCE_PAGES,
  CREATE_PAGES,
  GIFT_PAGES,
  PRESERVE_PAGES,
  FLORIDA_PAGES,
  INFO_PAGES,
  ACCOUNT_PAGES,
  WIZARDS,
} = TERMS;

const OPTIONS = {
  digitize: {
    title: 'Digitize',
    key: 'digitize',
    options: DIGITIZE_PAGES,
  },
  enhance: {
    title: 'Restore',
    key: 'enhance',
    options: ENHANCE_PAGES,
  },
  create: {
    title: 'Print',
    key: 'create',
    options: CREATE_PAGES,
  },
  gift: {
    title: 'Gift',
    key: 'gift',
    options: GIFT_PAGES,
  },
  preserve: {
    title: 'Preserve',
    key: 'preserve',
    options: PRESERVE_PAGES,
  },
  florida: {
    title: 'Florida',
    key: 'florida',
    options: FLORIDA_PAGES,
  },
  info: {
    title: 'Info',
    key: 'info',
    options: INFO_PAGES,
  },
  pod: {
    title: 'Commercial',
    key: 'pod',
    options: [
      {
        label: 'Pod',
        value: 'pod',
        path: 'pod',
      },
      {
        label: 'Print on Demand',
        value: 'printOnDemand',
        path: 'print-on-demand',
      },
    ],
  },
  printPal: {
    title: 'Print Pal',
    key: 'printPal',
    options: [
      {
        label: 'Print Pal - home page',
        value: 'printPal',
        path: 'print-pal',
      },
      {
        label: 'Print Pal - enhance wizard',
        value: 'printPalEnhance',
        path: 'print-pal/enhance-wizard',
      },
      {
        label: 'Print Pal - create wizard',
        value: 'printPalCreate',
        path: 'print-pal/create-wizard',
      },
    ],
  },
  account: {
    title: 'Account',
    key: 'account',
    options: ACCOUNT_PAGES,
  },
  wizards: {
    title: 'Wizards',
    key: 'wizards',
    options: WIZARDS,
  },
};

const b = bem('help-center-page');

export default {
  components: {
    HelpCenters,
    PageHeader,
  },
  data() {
    return {
      title: 'Help center',
      options: OPTIONS,
      firstPush: true,
      selectValue: {
        digitize: DIGITIZE_PAGES[0].value,
        enhance: ENHANCE_PAGES[0].value,
        create: CREATE_PAGES[0].value,
        gift: GIFT_PAGES[0].value,
        preserve: PRESERVE_PAGES[0].value,
        florida: FLORIDA_PAGES[0].value,
        info: INFO_PAGES[0].value,
        account: ACCOUNT_PAGES[0].value,
        wizards: WIZARDS[0].value,
        pod: 'pod',
        printPal: 'printPal',
      },
      currentTab: 'digitize',
      tabTitle: 'Digitize',
      selectedStepIndex: 0,
      selectedStep: null,
      STEP_NAME,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getPagesHelpCenterAction: 'helpCenter/getPagesHelpCenter',
      createHintPageHelpCenterAction: 'helpCenter/createHintPageHelpCenter',
      editHintPageHelpCenterAction: 'helpCenter/editHintPageHelpCenter',
      deletePageHelpCenterAction: 'helpCenter/deletePageHelpCenter',
      createCategoriesHelpCenterAction: 'helpCenter/createCategoriesHelpCenter',
      editCategoriesHelpCenterAction: 'helpCenter/editCategoriesHelpCenter',
      deleteCategoriesHelpCenterAction: 'helpCenter/deleteCategoriesHelpCenter',
      changePositionHelpCenterAction: 'helpCenter/changePositionHelpCenter',
      getWizardStepsAction: 'wizards/getWizardSteps',
      createWizardHelpCenterAction: 'wizards/createWizardHelpCenter',
      editWizardHelpCenterAction: 'wizards/editWizardHelpCenter',
      deleteWizardHelpCenterAction: 'wizards/deleteWizardHelpCenter',
      createCategoriesWizardHelpCenterAction: 'wizards/createCategoriesWizardHelpCenter',
      editCategoriesWizardHelpCenterAction: 'wizards/editCategoriesWizardHelpCenter',
      deleteCategoriesWizardHelpCenterAction: 'wizards/deleteCategoriesWizardHelpCenter',
      changePositionWizardHelpCenterAction: 'wizards/changePositionWizardHelpCenter',
      getPagesListAction: 'collections/getPagesList',
    }),
    getPagesHelpCenter(type) {
      this.getPagesHelpCenterAction(type);
    },
    getPath(key, value) {
      const { options } = this.options[key];
      const { path } = options.find((item) => item.value === value);
      return path;
    },
    getTitle(key, value) {
      const { options } = this.options[key];
      const { label } = options.find((item) => item.value === value);
      return label;
    },
    updateData() {
      const value = this.selectValue[this.currentTab];
      const path = this.getPath(this.currentTab, value);
      this.getPagesHelpCenter(path);
    },
    onSelect(key, value) {
      this.currentTab = key;
      this.tabTitle = this.getTitle(key, value);
      const path = this.getPath(key, value);
      this.selectValue = {
        ...this.selectValue,
        [key]: value,
      };
      if (key === 'wizards') {
        this.getWizardStepsAction(path);
      } else {
        this.getPagesHelpCenter(path);
      }
    },
    createHintPageHelpCenter(body) {
      this.createHintPageHelpCenterAction({
        ...body,
        stepId: 1,
        page: this.getPath(this.currentTab, this.selectValue[this.currentTab]),
      });
    },
    createCategoriesHelpCenter(body) {
      this.createCategoriesHelpCenterAction({
        ...body,
        page: this.getPath(this.currentTab, this.selectValue[this.currentTab]),
      });
    },
    selectStep(wizardSteps, index) {
      const section = wizardSteps[index];
      this.selectedStep = {
        ...section,
        orderSections: section.orderSections.map((item) => ({
          ...item,
        })),
      };
      this.selectedStepIndex = index;
    },
    createWizardHelpCenter(values) {
      const productName = this.getPath(this.currentTab, this.selectValue[this.currentTab]);
      this.createWizardHelpCenterAction({
        body: {
          ...values,
          stepId: this.selectedStep?.id,
        },
        productName,
      });
    },
    editWizardHelpCenter(values) {
      const {
        id,
        ...newValues
      } = values;
      const productName = this.getPath(this.currentTab, this.selectValue[this.currentTab]);

      this.editWizardHelpCenterAction({
        body: {
          ...newValues,
          stepId: this.selectedStep?.id,
        },
        id,
        productName,
      });
    },
    deleteWizardHelpCenter(values) {
      const productName = this.getPath(this.currentTab, this.selectValue[this.currentTab]);

      this.deleteWizardHelpCenterAction({
        id: values,
        productName,
      });
    },
    createCategoriesWizardHelpCenter(values) {
      const productName = this.getPath(this.currentTab, this.selectValue[this.currentTab]);
      this.createCategoriesWizardHelpCenterAction({
        body: {
          ...values,
          stepId: this.selectedStep?.id,
        },
        productName,
      });
    },
    editCategoriesWizardHelpCenter(values) {
      const { categoryId, ...body } = values;
      const productName = this.getPath(this.currentTab, this.selectValue[this.currentTab]);

      this.editCategoriesWizardHelpCenterAction({
        body: {
          ...body,
          stepId: this.selectedStep?.id,
        },
        categoryId,
        productName,
      });
    },
    deleteCategoriesWizardHelpCenter(values) {
      const productName = this.getPath(this.currentTab, this.selectValue[this.currentTab]);
      this.deleteCategoriesWizardHelpCenterAction({
        id: values,
        productName,
      });
    },
    changePositionWizardHelpCenter(values) {
      const productName = this.getPath(this.currentTab, this.selectValue[this.currentTab]);
      this.changePositionWizardHelpCenterAction({
        body: values,
        productName,
      });
    },
  },
  mounted() {
    this.updateData();
    this.getPagesListAction();
  },
  computed: {
    ...mapState({
      pageHelpCenter: (state) => state.helpCenter.pageHelpCenter,
      wizardSteps: (state) => state.wizards.wizardSteps,
      pageList: (state) => state.collections.collectionsPages,
    }),
  },
  watch: {
    wizardSteps: {
      handler(newValue, oldValue) {
        if (oldValue.length === 0 && newValue.length > 0) {
          this.selectStep(newValue, 0);
        }

        if (oldValue.length > 0 && newValue.length > 0) {
          this.selectStep(newValue, this.selectedStepIndex);
        }
      },
      deep: true,
    },
    pageList: {
      handler(newValue) {
        this.options = newValue.reduce((acc, item) => {
          if (['photo_art', 'photo_restoration', 'pm_cart', 'printed_story', 'proof'].includes(item)) {
            return acc;
          }
          return {
            ...acc,
            pod: {
              ...acc.pod,
              options: [...acc.pod.options,
                {
                  label: `${item.replaceAll('_', ' ')}(main page)`,
                  value: `pod?pageKey=${item}`,
                  path: `pod?pageKey=${item}`,
                },
                {
                  label: `${item.replaceAll('_', ' ')}(image gallery page)`,
                  value: `image-gallery?pageKey=${item}`,
                  path: `image-gallery?pageKey=${item}`,
                },
                {
                  label: `${item.replaceAll('_', ' ')}(wizard page)`,
                  value: `photo-art-editor?pageKey=${item}`,
                  path: `photo-art-editor?pageKey=${item}`,
                },
              ],
            },
          };
        }, OPTIONS);
      },
      deep: true,
    },
  },
};
</script>

<template>
  <PageHeader :title="title" />
  <div :class="b('')">
    <div :class="b('headers')">
      <div :class="b('buttons-menu')">
        <a-dropdown-button
          :class="b('buttons-menu-item')"
          v-for="option in options"
          :key="option.key"
        >
          {{ option.title }}
          <template #overlay>
            <a-menu>
              <a-menu-item
                v-for="item in option.options"
                :key="item.value"
                @click="this.onSelect(option.key, item.value)"
              >
                {{ item.label }}
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown-button>
      </div>
      <h2>Active tab: {{ tabTitle }}</h2>
      <div />
    </div>
    <template v-if="this.currentTab !== 'wizards'">
      <help-centers
        :helpCenters="(pageHelpCenter?.helpCenters || [])"
        :categories="pageHelpCenter?.helpCenters?.filter(item => item.isCategory) || []"
        :currentTab="this.getPath(this.currentTab, this.selectValue[this.currentTab])"
        :create-hint="(createHintPageHelpCenter)"
        :edit-hint="(value) => editHintPageHelpCenterAction(value)"
        :delete-hint="deletePageHelpCenterAction"
        :create-category="(createCategoriesHelpCenter)"
        :edit-category="(value) => editCategoriesHelpCenterAction(value)"
        :delete-category="deleteCategoriesHelpCenterAction"
        :change-position="changePositionHelpCenterAction"
        :withCreatedLink="this.getPath(
           this.currentTab,
           this.selectValue[this.currentTab]
        ) === 'forever-care'"
        :createdLinkPage="this.selectValue[this.currentTab]"
      />
    </template>
    <template v-else>
      <span :class="b('step-name')">
        Step name:
        {{STEP_NAME[this.selectedStep?.name] || this.selectedStep?.name || ''}}
      </span>
      <help-centers
        :helpCenters="(this.selectedStep?.helpCenters || [])"
        :categories="this.selectedStep?.helpCenters?.filter(item => item.isCategory) || []"
        :create-hint="(createWizardHelpCenter)"
        :edit-hint="editWizardHelpCenter"
        :delete-hint="deleteWizardHelpCenter"
        :create-category="(createCategoriesWizardHelpCenter)"
        :edit-category="editCategoriesWizardHelpCenter"
        :delete-category="deleteCategoriesWizardHelpCenter"
        :change-position="changePositionWizardHelpCenter"
      />
      <div :class="b('buttons')">
        <button
          :class="b('button', { back: true })"
          v-if="selectedStepIndex > 0"
          @click="selectStep(wizardSteps, selectedStepIndex - 1)"
        >
          Back
        </button>
        <button
          :class="b('button', { next: true })"
          v-if="selectedStepIndex < wizardSteps.length - 1"
          @click="selectStep(wizardSteps, selectedStepIndex + 1)"
        >
          Next
        </button>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/media";
@import "@/styles/fonts";
.help-center-page {
  margin: 0 20px;
  &__headers {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
  }
  &__buttons-menu-item {
    margin-right: 20px;
  }
  &__order-buttons {
    display: flex;
    flex-direction: column;
  }
  &__order-button-up {
    margin-bottom: 10px;
  }

  &__hint-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 1544px;
    margin: 0 auto;
  }

  &__create-hint-button {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__step-name {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    font-size: 20px;

    @include mediaMinMax(1025, $normal) {
      padding: vw-full(20);
      font-size: vw-full(20);
    }
  }

  &__buttons {
    margin: 40px auto;
    width: 100%;
    max-width: 1544px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include mediaMinMax(1025, $normal) {
      margin: vw-full(40) auto;
      max-width: vw-full(1544);
    }
  }

  &__button {
    width: 170px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    outline: none;
    border: none;
    box-shadow: 3.8px 5.9px 9.9px 3.1px rgba(95, 138, 164, 0.42);
    background-color: $horizon;
    text-transform: uppercase;
    font-size: 22px;
    font-weight: 500;
    text-align: center;
    color: $white-color;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(170);
      height: vw-full(70);
      font-size: vw-full(22);
    }
    @include mediaMinMax(481, $small) {
      width: vw-mobile(279);
      height: vw-mobile(47);
      font-size: vw-mobile(15);
    }
    @include media($mini) {
      width: 279px;
      height: 47px;
      font-size: 15px;
    }

    &_next {
      margin-left: auto;
    }

    &_back {
      margin-right: auto;
    }
  }
}

button:first-child {
  margin-right: 20px;
}
</style>
